import React from 'react';
import Truncate from 'react-truncate';

import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink, DynamicMediaItem } from '@uncinc/react-drupal-core';

import { dateFormatter } from '../../../helpers';
import ThemesLabels from '../../ThemesLabels';
import WysiwygField from '../../WysiwygField';

import {
  SCREEN_TABLET,
  SCREEN_NORMAL,
  TAXONOMY_MEDIA_CATEGORY_MAGAZINE,
} from '../../../config/constants';

import './style.scss';

const TeaserBig = ({ node, typeLabel, highlighted = false, large = false }) => {
  const title = node.title[0].value;
  const isOfTypeMagazine = node.field_media_category?.[0]?.target_id === TAXONOMY_MEDIA_CATEGORY_MAGAZINE;
  const lang = 'nl';
  const image = node?.field_media_item[0];
  const media = node?.field_media_item[0];
  const generatedImage = node?.field_media_item[0]?.entity?.field_poster_image?.[0];
  if (generatedImage) {
    generatedImage.bundle = 'image';
    generatedImage.title = image.title || title;
  }
  const themes = node.field_themes;
  const date = node.field_publish_date?.[0]?.value || node.created[0]?.value;
  const url = node.paths.nl;
  const summary = node.body?.[0]?.summary || node.body?.[0]?.value;


  const { width } = useWindowDimensions();
  const isMobile = width < SCREEN_TABLET;
  const isTablet = width >= SCREEN_TABLET && width < SCREEN_NORMAL;

  // Determine which media to display
  let mediaToDisplay = null;
  let aspectRatio = '4_3';
  let mediaClassName = '';

  if (highlighted && image) {
    mediaToDisplay = media;
    aspectRatio = isTablet ? '16_9' : '4_3';
  }

  if (!highlighted && isOfTypeMagazine && generatedImage) {
    mediaToDisplay = generatedImage;
    aspectRatio = '1_1_41';
    mediaClassName = 'isOfTypeMagazine';
  }

  if (!highlighted && !isOfTypeMagazine && image) {
    mediaToDisplay = image;
    aspectRatio = '4_3';
  }

  return (
    <div className={`TeaserBig ${highlighted ? 'highlighted' : ''}${large ? 'large' : ''}`}>
      <div className="TeaserBig__image">
        {mediaToDisplay && (
          <DynamicMediaItem
            className={mediaClassName}
            media={mediaToDisplay}
            imageAspectRatio={aspectRatio}
          />
        )}
        {!mediaToDisplay && (
          <div className="TeaserBig__image" />
        )}
        <div className="triangle triangle--medium" />
      </div>

      <div className="TeaserBig__textBox">
        <div className="TeaserBig__info">
          <p className="TeaserBig__info__type">
            {typeLabel}
          </p>
          <span className="dot">&bull;</span>
          <p>{dateFormatter(date, lang, isMobile && true)}
          </p>
        </div>
        <div className="TeaserBig__content">

          <div className="TeaserBig__heading">
            <CoreLink className="teaser-link" href={url}>
              <Truncate lines={4} ellipsis="...">
                {title}
              </Truncate>
            </CoreLink>
          </div>

          {summary && (
            <Truncate lines={highlighted ? 6 : 3} ellipsis="...">
              <WysiwygField
                html={summary}
                className="TeaserBig__content__summary"
              />
            </Truncate>
          )}

          {themes.length > 0 &&
            <ThemesLabels themes={themes.slice(0, 2)} />}
        </div>
      </div>
    </div>
  );
};

export default TeaserBig;
